<template>
  <!-- <pre>{{ socialField }}</pre> -->
  <div v-if="isLoading">
    <OtherLoading variant="dark" />
  </div>

  <template v-else>
    <div class="content-edit-profile space-footer">
      <div
        v-html="$config.header_edit_profile_form"
        class="px-3 mt-3"
        v-if="$config.header_edit_profile_form"
      ></div>
      <template v-if="!isAddOptionalTelephone">
        <ProfileForm
          :fields="customField.filter(el => el.group_id == 1)"
          :v$="v$"
          :form="form"
          @addOptionalTelephone="addOptionalTelephone"
          :saveIDCard="saveIDCard"
          :isEdit="isEdit"
          :componentKey="componentKey"
          :isOldEnough="isOldEnough"
        />
        <ProfileForm
          class="mt-3"
          v-if="customField.filter(el => el.group_id == 2).length > 0"
          :fields="customField.filter(el => el.group_id == 2)"
          :v$="v$"
          :form="form"
          :componentKey="componentKey"
        />
        <DynamicForm
          :fields="socialField"
          :v$="v$"
          keyFormValidate="socialField"
        />
        <div style="margin-top: 10px">
          <DynamicForm
            :fields="dynamicField"
            :v$="v$"
            isEdit
            :cloneFieldDynamic="cloneFieldDynamic"
          />
        </div>
      </template>
      <OptionalTelephone
        v-else
        :form="form"
        @saveOptionalTelephone="saveOptionalTelephone"
        @close="closeOptionalTelephone"
      />
      <div
        v-html="$config.footer_edit_profile_form"
        class="px-3 mt-3"
        v-if="$config.footer_edit_profile_form"
      ></div>
    </div>

    <div class="consent-container mb-3">
      <PrivacyPolicyCheckbox
        v-if="!this.$BRAND.includes('cos')"
        type="term"
        v-model="form.is_consent"
        :login-type="form.login_type"
        :required="true"
        :show-tab-required="true"
        disabled
        checkbox-id="term-checkbox"
      />
      <PrivacyPolicyCheckbox
        type="policy"
        v-model="form.is_message_policy"
        :login-type="form.login_type"
        checkbox-id="policy-checkbox"
      />

      <ConsentItem
        v-for="items of consentList"
        :key="`${items.id}-${items.name}`"
        :item="items"
      />
    </div>

    <div
      class=""
      :class="{
        'bg-white': !lineLayout.includes('Minimal'),
        'mb-3': $isMinimalProfile
      }"
      v-if="!isAddOptionalTelephone"
    >
      <c-btn
        class="w-100 mb-2"
        @click="validateEmail()"
        variant="confirm-primary"
        :disabled="
          disabledBtn ||
          isDisabledButton ||
          !isConsentError ||
          form.is_consent != 1
        "
        data-test="profile-edit-save-btn"
      >
        <template data-lang="save_change" v-if="$isMinimalMinibar || $isMinimalProfileBanner">
          {{ $t("save_change") }}
        </template>
        <template data-lang="save" v-else> {{ $t("save") }} </template>
      </c-btn>
    </div>

    <div
      :class="{ 'bg-white': !lineLayout.includes('Minimal') }"
      v-if="!isAddOptionalTelephone && $isMinimalMinibar"
    >
      <c-btn
        class="w-100 mt-3"
        @click="closeEditPanel()"
        variant="outline-primary"
        data-test="profile-edit-cancel-btn"
      >
        <template data-lang="cancel_change" v-if="$isMinimalMinibar">
          {{ $t("cancel_change") }}
        </template>
        <template data-lang="cancel" v-else> {{ $t("cancel") }} </template>
      </c-btn>
    </div>
    <div
      :class="{ 'bg-white': !lineLayout.includes('Minimal') }"
      v-if="!isAddOptionalTelephone && !$isMinimalMinibar"
    >
      <c-btn
        class="w-100"
        @click="closeEditPanel()"
        variant="outline-primary"
        :disabled="disabledBtn || isDisabledButton || !isConsentError"
        data-test="profile-edit-cancel-btn"
      >
        {{ $isMinimalProfileBanner ? $t("cancel_change") : $t("cancel") }}
      </c-btn>
    </div>

    <ModalPolicy ref="modalPolicy" />
    <ModalTermAndConditios ref="modalTerms" />
  </template>
</template>

<script>
const moment = require("moment");
import OtherLoading from "@/components/other/OtherLoading";
import ModalPolicy from "@/components/alert-modal/ModalPolicy";
import ModalTermAndConditios from "@/components/alert-modal/ModalTermAndConditios";
import { fieldInForm2 } from "@/assets/json/fieldProfile.js";
import ProfileForm from "@/components/form/ProfileForm.vue";

import PreviewCustomObject from "@/views/page/customForm/detail.vue";
import DynamicForm from "@/components/form/DynamicForm.vue";
import OptionalTelephone from "@/components/form/OptionalTelephone.vue";
import InvoiceAddress from "@/components/form/InvoiceAddress";
import ShippingAddress from "@/components/form/ShippingAddress";
import ContactAddress from "@/components/form/ContactAddress";
import ConsentItem from "@/components/profile/edit/ConsentItem.vue";
import PrivacyPolicyCheckbox from "@/components/profile/edit/PrivacyPolicyCheckbox.vue";
import { useDialog } from "@/services/dialogService";

export default {
  components: {
    OtherLoading,
    ModalPolicy,
    ModalTermAndConditios,
    PreviewCustomObject,
    ProfileForm,
    DynamicForm,
    OptionalTelephone,
    InvoiceAddress,
    ShippingAddress,
    ContactAddress,
    ConsentItem,
    PrivacyPolicyCheckbox
  },
  props: {
    form: {
      required: true,
      type: Object
    },

    hideTerm: {
      required: false
    },
    consentShow: {
      required: true,
      type: Boolean
    },
    customField: {
      required: true,
      type: Array
    },
    questionList: {
      required: true,
      type: Array
    },
    v$: {
      required: true,
      type: Object
    },
    isEdit: {
      required: true,
      type: Boolean,
      default: false
    },
    dynamicField: {
      required: false
    },
    defaultValueField: {
      required: false,
      type: Array,
      default: () => []
    },
    socialField: {
      required: false,
      type: Array
    },
    hasSubmit: {
      required: false,
      default: false
    },

    isDisabledButton: {
      required: false
    },
    saveIDCard: {
      required: false
    },
    consentList: {
      required: false,
      default: []
    },
    componentKey: {
      required: false,
      type: Boolean,
      default: false
    },
    isOldEnough: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  data() {
    return {
      successMessage: "",
      emailFirst: "",
      disabledBtn: false,
      displayRightRequest:
        this.$store.state.theme.line_display_right_request_link == "1"
          ? true
          : false,
      day: [
        { value: "01", title: "01", disabled: false },
        { value: "02", title: "02", disabled: false },
        { value: "03", title: "03", disabled: false },
        { value: "04", title: "04", disabled: false },
        { value: "05", title: "05", disabled: false },
        { value: "06", title: "06", disabled: false },
        { value: "07", title: "07", disabled: false },
        { value: "08", title: "08", disabled: false },
        { value: "09", title: "09", disabled: false },
        { value: "10", title: "10", disabled: false },
        { value: "11", title: "11", disabled: false },
        { value: "12", title: "12", disabled: false },
        { value: "13", title: "13", disabled: false },
        { value: "14", title: "14", disabled: false },
        { value: "15", title: "15", disabled: false },
        { value: "16", title: "16", disabled: false },
        { value: "17", title: "17", disabled: false },
        { value: "18", title: "18", disabled: false },
        { value: "19", title: "19", disabled: false },
        { value: "20", title: "20", disabled: false },
        { value: "21", title: "21", disabled: false },
        { value: "22", title: "22", disabled: false },
        { value: "23", title: "23", disabled: false },
        { value: "24", title: "24", disabled: false },
        { value: "25", title: "25", disabled: false },
        { value: "26", title: "26", disabled: false },
        { value: "27", title: "27", disabled: false },
        { value: "28", title: "28", disabled: false },
        { value: "29", title: "29", disabled: false },
        { value: "30", title: "30", disabled: false },
        { value: "31", title: "31", disabled: false }
      ],
      month: [
        { value: "01", title: this.$t("month_january"), disabled: false },
        { value: "02", title: this.$t("month_february"), disabled: false },
        { value: "03", title: this.$t("month_march"), disabled: false },
        { value: "04", title: this.$t("month_april"), disabled: false },
        { value: "05", title: this.$t("month_may"), disabled: false },
        { value: "06", title: this.$t("month_june"), disabled: false },
        { value: "07", title: this.$t("month_july"), disabled: false },
        { value: "08", title: this.$t("month_august"), disabled: false },
        { value: "09", title: this.$t("month_september"), disabled: false },
        { value: "10", title: this.$t("month_october"), disabled: false },
        { value: "11", title: this.$t("month_november"), disabled: false },
        { value: "12", title: this.$t("month_december"), disabled: false }
      ],
      isLoading: false,
      tabIndex: null,
      customObjectForm: [],
      tabsName: "",
      fromDateMenu: false,
      fromDateVal: null,
      panels: [0, 1, 2],
      isAddOptionalTelephone: false,
      cloneFieldDynamic: []
    };
  },
  created() {
    this.emailFirst = this.form.email;
    this.handleMonth(this.form.birthday_month);
    this.handleDayChange(this.form.birthday_day);
    this.getCustomObjectForm();
    this.cloneFieldDynamic = JSON.parse(JSON.stringify(this.form.custom_field));
  },
  computed: {
    isConsentError() {
      let check = this.consentList
        .filter(el => el.is_required_in_edit_profile)
        .every(el => el.is_consent == 1);

      return check;
    }
  },
  watch: {
    tabIndex(val) {
      if (this.isAddOptionalTelephone)
        return (this.isAddOptionalTelephone = false);
    }
  },
  updated: function () {
    var $this = this;

    if (this.$route.query.id)
      this.$nextTick(function () {
        let index = $this.customObjectForm.findIndex(
          el => el.id == $this.$route.query.id
        );
        if (index != -1) {
          $this.tabIndex = `customObject-${$this.customObjectForm[index].id}`;
          $this.tabsName = $this.customObjectForm[index].name;
          return $this.$router
            .replace(
              `/manage/profile?check=true${
                this.$route.query.view ? "&view=" + this.$route.query.view : ""
              } `
            )
            .catch(err => {});
        }
      });
  },
  methods: {
    saveOptionalTelephone(val) {
      this.form.optional_telephone = val.join(",");
      this.isAddOptionalTelephone = false;
    },
    addOptionalTelephone() {
      this.isAddOptionalTelephone = true;
    },
    closeOptionalTelephone() {
      this.isAddOptionalTelephone = false;
    },
    resetForm() {
      this.v$.dynamicField.$reset();
    },

    handleMonth(vals) {
      let length = this.day.length - 1;
      let disabledMonth = ["04", "06", "09", "11"];
      if (vals == "02") {
        this.day[length].disabled = true;
        this.day[length - 1].disabled = true;
      } else if (disabledMonth.includes(vals)) {
        this.day[length].disabled = true;
        this.day[length - 1].disabled = false;
      } else {
        this.day[length].disabled = false;
        this.day[length - 1].disabled = false;
      }
    },
    handleDayChange(vals) {
      let disabledMonth = ["04", "06", "09", "11"];
      if (vals == 30 || vals == 31) {
        if (vals == 31) {
          this.$nextTick(() => {
            this.month.map(el => {
              if (disabledMonth.includes(el.value)) {
                el.disabled = true;
              }
              return { ...el };
            });
            this.month = this.month;
          });
        } else if (vals == 30) {
          this.month.map(el => {
            el.disabled = false;
            return { ...el };
          });
        }
        this.$nextTick(() => {
          this.month[1].disabled = true;
        });
      } else {
        this.month.map(el => {
          el.disabled = false;
          return { ...el };
        });
      }
    },

    handleLink() {
      if (this.$store.state.theme.is_right_request_url == "1")
        return window.open(this.$store.state.theme.right_request_url, "_blank");

      this.$router.push("/setting");
    },
    checkFieldConditon(obj) {
      return obj.field_conditions[0] ? obj.field_conditions[0].value : "text";
    },
    checkIsProfile(val) {
      const findField = fieldInForm2.find(el => el.id == val);

      return findField ? findField.key : false;
    },
    checkMaxMin(item, key, field_id) {
      if (field_id == 9) {
        const condition = item.find(el => el.field_condition_type_id == 7);

        if (condition)
          if (key == 3) {
            return condition.value
              ? this.$moment()
                  .subtract(condition.value, "year")
                  .format("YYYY-01-01")
              : false;
          } else if (key == 4) return this.$moment().format("YYYY-MM-DD");
      }
      const conditon = item.find(el => el.field_condition_type_id == key);
      if (conditon) return conditon.value ? conditon.value : false;
      return false;
    },
    isMaxMin: function (value, e) {
      try {
        const val = e.target.value;

        const max = Number(e.target.max);
        const min = Number(e.target.min);
        if (val && e.target.type == "number" && min && val < min) {
          return (e.target.value = min);
        }
        if (val && e.target.type == "number" && max && val > max) {
          return (e.target.value = max);
        }
      } catch (error) {
        console.log(error);
      }
    },
    isNumber: function (e) {
      const maxlen = e.target.maxLength;
      const val = e.target.value;

      if (
        (e.key == "e" || e.charCode == 45 || e.charCode == 46) &&
        e.target.type == "number"
      ) {
        return e.preventDefault();
      }
      if (maxlen == -1) {
        return val;
      }

      if (val.length > maxlen - 1) {
        return e.preventDefault();
      }
    },
    handleChangeGender(val) {
      this.form.gender = val;
    },
    dateFormat() {
      let today = new Date();
      return this.$moment(today).format();
    },
    async nextPage() {
      // this.v$.form.$touch();

      this.v$.form.$touch();
      this.v$.socialField.$touch();

      if (this.v$.form.$error || this.v$.socialField.$error) {
        return;
      }
      if (this.dynamicField.length == 0) {
        return this.validateEmail();
      }
      this.tabIndex = 1;
    },
    async validateEmail() {
      // if (!this.isConsentError) return (this.consentError = true);
      if (this.hasSubmit) {
        return this.$emit("onSubmit");
      }

      if (this.form.email !== this.emailFirst) {
        this.v$.form.$touch();
        if (this.v$.form.$error) {
          return;
        }

        let chkEmail = {
          Email: this.form.email
        };
        this.isLoading = true;

        this.$axios
          .post(`/api/v1/user/ValidateEmail`, chkEmail)
          .then(async data => {
            if (data.result == 1) {
              this.validationFormEdit();
            } else {
              this.isLoading = false;
              if (this.$isMinimalProfile)
                return this.$store.commit("setEmailDuplicate", true);
              await this.dialog.showError({ text: this.$t("email_already_registered") });
            }
          })
          .catch(async error => {
            this.isLoading = false;
            if (this.$isMinimalProfile)
              return this.$store.commit("setEmailDuplicate", true);
            await this.dialog.showError({ text: this.$t("email_already_registered") });
          });
      } else {
        this.validationFormEdit();
      }
    },
    isOtherField($fields) {
      if ($fields) {
        let find = $fields.field_choices
          ? $fields.field_choices.find(
              el =>
                el.name ==
                this.form[this.checkIsProfile($fields.field_profile_type_id)]
            )
          : null;
        return find ? (find.choice_type_id == 3 ? true : false) : false;
      }
    },
    async validationFormEdit() {
      this.v$.$touch();

      this.v$.dynamicField.$touch();
      this.v$.socialField.$touch();
      console.log(this.isOldEnough);
      if (
        this.v$.dynamicField.$error ||
        this.v$.form.$error ||
        this.v$.socialField.$error ||
        this.v$.isOldEnough.$error ||
        !this.isOldEnough
      ) {
        return;
      }

      let dynamic = [];
      const fieldsForSubmit = [
        ...this.dynamicField,
        ...this.defaultValueField
      ];
      for (const fields of fieldsForSubmit) {
        let target_id = 0;
        if (fields.field_choices.length > 0) {
          const findFieldId = fields.field_choices.find(
            choice => choice.name == fields.user_answer
          );
          if (findFieldId) {
            target_id = findFieldId.id;
          }
        }
        dynamic.push({
          id: fields.id,
          value: fields.user_answer,
          target_id: target_id
        });
      }
      let objTemp = [];

      for (const x of dynamic) {
        var findField = fieldsForSubmit.find(field => field.id == x.id);

        if (x.value && typeof x.value == "object") {
          if (x.value.length > 0) {
            for (const a of x.value) {
              const { id } = findField.field_choices.find(
                choice => choice.name == a
              );
              objTemp.push({
                id: x.id,
                value: a,
                target_id: id
              });
            }
          }
        } else {
          objTemp.push(x);
        }
      }

      this.isLoading = true;

      this.disabledBtn = true;

      delete this.form.birthday;
      if (this.$BRAND.includes("cos")) {
        this.form.is_consent = 1;
        this.form.is_message_policy = 1;
      }
      let payload = {
        ...this.form,
        user_additional_consent_insert_List: this.consentList.map(el => {
          return { additional_consent_id: el.id, is_consent: el.is_consent };
        }),
        custom_field: objTemp.filter(el => el.value)
      };

      for (const checkForm of this.customField) {
        if (this.isOtherField(checkForm))
          payload[this.checkIsProfile(checkForm.field_profile_type_id)] =
            checkForm.other_value;
      }

      // payload.custom_field = dynamic;
      let hasBirthDay = this.customField.find(
        el => el.field_profile_type_id == 9
      );

      if (hasBirthDay && this.yearFormat == 1)
        if (payload.birthday_year)
          payload.birthday_year = moment(
            `${payload.birthday_day}/${payload.birthday_month}/${payload.birthday_year}`,
            "DD/MM/YYYY"
          )
            .subtract(543, "y")
            .year();
      if (!payload.birthday_day) payload.birthday_day = "01";
      if (!payload.birthday_month) payload.birthday_month = "01";
      if (!payload.birthday_year) payload.birthday_year = "1753";
      payload.social = this.socialField.map(el => {
        return {
          // ...el,
          id: el.answer_id || 0,
          social_media_type_id: el.id,
          value: el.user_answer,
          user_guid: payload.user_guid
        };
      });

      try {
        const data = await this.$axios.post(
          `/api/v1/user/EditUserProfile`,
          payload
        );

        if (data.result == 1) {
          if (this.customField.length > 0) {
            await this.updateCustomField();
          } else {
            // this.$store.dispatch("refreshUserProfile");
            if (!this.componentKey) this.$router.push("/profile");
            this.$emit("onFinish");
          }
        } else {
          this.disabledBtn = false;
          const errorMessage = data.detail[0] ? data.detail[0] : data.message;
          await this.dialog.showError({ text: errorMessage });
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error.message);
        this.disabledBtn = false;

        await this.dialog.showError({ text: this.$t("profile_update_error") });
        this.isLoading = false;
      }
    },
    async updateCustomField() {
      let body = {
        user_guid: this.form.user_guid,
        admin_user_guid: this.form.user_guid,
        question_list: this.questionList
      };
      const data = await this.$axios.put(
        `/api/v1/User/update_custom_answer`,
        body
      );

      if (data.result == 1) {
        if (!this.componentKey) this.$router.push("/profile");
        this.isLoading = false;
        this.$emit("onFinish");
      } else {
        this.disableBtn = false;
        this.isLoading = false;
        const errorMessage = data.detail[0] ? data.detail[0] : data.message;
        await this.dialog.showError({ text: errorMessage });
      }
    },
    renderConsentParts(items) {
      const parts = items.parsedDescription.map(part => {
        if (part === "{{term}}")
          return `<span class="text-underline" data-consent="term">${this.$t(
            "term"
          )}</span>`;
        if (part === "{{policy}}")
          return `<span class="text-underline" data-consent="policy">${this.$t(
            "policy"
          )}</span>`;
        return part;
      });
      let html = parts.join("");
      if (items.is_required_in_edit_profile == 1)
        html += `<span class="text-consent-danger">&nbsp;*</span>`;
      return html;
    },
    handleConsentClick(event) {
      const target = event.target.closest("[data-consent]");
      if (!target) return;
      if (target.dataset.consent === "term") this.modalTermsOpen(false);
      if (target.dataset.consent === "policy") this.modalPolicyOpen(false);
    },
    modalPolicyOpen(flag = true) {
      if (this.$store.state.theme.is_custom_privacy_link == "1" && flag)
        return window.open(this.$store.state.theme.consent_url_link, "_blank");
      this.emitter.emit("showModal", "policy");
    },
    modalTermsOpen(flag = true) {
      if (this.$store.state.theme.is_term_and_con_url == "1" && flag)
        return window.open(this.$store.state.theme.term_and_con_url, "_blank");
      this.emitter.emit("showModal", "term");
    },
    async getCustomObjectForm() {
      const resp = await this.$axios.post(
        `/api/CustomObject/custom_object_head`,
        {
          user_guid: "" // อันนี้ของหน้า customer detail
        }
      );

      this.customObjectForm = resp.detail;
    },
    handleTabsChange(name) {
      this.tabsName = name;
      if (this.$route.query.view)
        return this.$router.replace(`/manage/profile?check=true`);
    },
    closeEditPanel() {
      this.$emit("closeEditPanel");
    },
    openLink(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .content-edit-profile {
  // background-color: #fff;
  //   border-radius: 5px;
  // height: 80vh;

  // margin-bottom: 65px;
}

.btn-edit {
  background-color: #000;
  color: #fff;
  width: 100%;
  border: none;
  padding: 10px 0;
}
.remark {
  color: red;
}

.custom-pd-tel {
  padding: 0 10px;
}
.footer-bottom {
  max-width: 800px;
  position: fixed;
  margin: auto;
}
.consent-text {
  font-size: var(--font-title-sm);
  color: #575757;
}
.text-underline {
  text-decoration: underline;
}
.div-space {
  margin: 90px 0px;
  background-color: #fff;
}
.label-text {
  color: black;
  font-size: var(--font-title-sm);
  margin-bottom: 5px;
  font-weight: 600;
  // color: #838383;
}
.tabs-with-button {
  // height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 227px);
}

.container-tabs {
  // height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 167px);
}

::v-deep .nav {
  width: max-content;
  flex-wrap: unset;
}
::v-deep .nav-wrapper {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
::v-deep .v-window-item.window-padding {
  padding-bottom: 95px;
}
.space-footer {
  padding-bottom: 10px;
}
.minimal-profile {
  padding: 1.5rem 1.1rem;
}
</style>
